<template>
  <div>
    <div class="inner-div">
      <div class="title">
        <img style="height: 6.5rem; width: 6.5rem;"
             :src="`${assetsUrl}imgs/course/cpa/logo .png`">
        <img class="logo-title"
             :src="`${assetsUrl}imgs/course/cpa/title.png`">
      </div>
      <div class="main-div">
        <div class="tiku-title">考试科目选择</div>
        <div class="tiku-main" >
          <a v-for="item of data.classesUrls" :key="item.id" @click="isIn(item)" :href="item.url" target="_blank" >
            <button :class="{'disable-in':item.signUp == 0,'able-in':item.signUp == 1}">
              <i class="iconfont icon-mima disable-icon" aria-hidden="true"></i>{{ item.name }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CpaAcc',
  components: {},
  data() {
    return {
      user: '',
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/'
    }
  },
  props: {
  planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  created() {
    console.log('22222222222', this.data)
  },
  methods: {
     isIn(item) {
     }
  }
}
</script>

<style scoped lang="less">
.outer-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.inner-div {
  width: 51.2rem;
  height: 38.4rem;
  //background-image: url("https://o2o-demo.oss-cn-hangzhou.aliyuncs.com/o2ostu/assets/imgs/course/cpa/cpa-cost-back%20.jpg");
  background-image: url("`https://static.51lss.com/o2ostu/assets/imgs/course/cpa/cpa-cost-back%20.jpg`");
  background-repeat: no-repeat;
  background-size:  100% 100%;
  margin: auto;
  //background-image: url(assets/imgs/course/cpa-cost-back .jpg) no-repeat;
}
.title{
  margin-left: 4.4rem;
  margin-top: 2.6rem;
}
.title img{
  display: inline-block;
}
.logo-title{
  margin-left: 2rem;
  width: 25rem;
  margin-top: .8rem;
}
.main-div{
  width: 45.75rem;
  height:23rem;
  background-color: white;
  border-radius: .6rem;
  margin-top: 3.4rem;
  margin-left: 2.7rem;
  box-shadow: 0 3px 13px rgba(0, 0, 0, .4);
}
.tiku-title{
  font-size: 1.5rem;
  color: #333;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
.tiku-main{
  width: 100%;
  height: 17rem;
  display: flex;
  flex-flow: row wrap;
  padding-left: 5rem;
  padding-top: 1rem;
}
button{
  height: 3.3rem;
  width: 15.8rem;
  border: none;
  margin-right: 4rem;
  font-size: 1rem;
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  line-height: 3.3rem;
  outline: none;
}
.able-in{
  color: #08528f;
  background-color: #d8edff;
  box-shadow: 0 2px 0 #b4deff;
}
.disable-in{
  color: #777;
  background-color: #d4dce2;
  box-shadow: 0 2px 0 #b3c0ca;
}
.able-in:hover{
  background-color: #98d172;
  color: white;
  box-shadow:none;
}
.disable-icon{
  font-size: 1.3rem;
  left: 0.5rem;
  float: left;
}

.able-in:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}

@media (min-height: 750px) and (max-height: 825px){
  .inner-div,.macc-main{
    margin-top: 5rem;
    margin-bottom: 1rem;

  }
}
@media (min-height: 600px) and (max-height: 750px){
  .inner-div,.macc-main{
    margin-top: 5rem;
    margin-bottom: 3rem;
  }
  .macc-main{
    margin-top: 5rem;
  }
}
@media (min-height: 600px) and (max-height: 680px){
  .macc-main{
    margin-top: 5rem;
  }
}
@media screen and (max-height: 600px){
  .inner-div,.macc-main{
    margin-top: 5rem;
  }
}
.macc-main{
  width: 51.3rem;
  height: 38.5rem;
  background-color: white;
  border:.05rem solid #E3E3E3;
}
.macc-logo-title{
  height:8.7rem;
  width:  100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title > div{
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title img{
  width: 14rem;
}
.macc-content{
  width:100%;
  height:29.7rem;
  position: relative;
}
.macc-content>.back-img{
  width:100%;
  height:100%;
}
.macc-content button{
  position: absolute;
  top:6rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: white;
  color: #208ca5;
  font-size: 1.1rem;
  box-shadow: 0 3px 0 #b1dbd9;
}
.macc-content > .mess-logo{
  width: 21.2rem;
  position: absolute;
  top: -10rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.macc-content button:hover{
  background-color: #98d172;
  color: white;
  box-shadow:none;
}

.macc-content button:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}

</style>
